import React, {lazy, Suspense} from 'react'
import LoadingCircle from "../../Loading/LoadingCircle";

const DevotionDetailLazy = lazy(() =>
    import('./DevotionDetail')
)

const DevotionDetail = props => (
    <Suspense fallback={<LoadingCircle/>}>
        <DevotionDetailLazy {...props} />
    </Suspense>
)

export default DevotionDetail
